import * as React from "react";
const SvgBullseye20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M11.86 10a1.87 1.87 0 1 1-3.74 0 1.87 1.87 0 0 1 3.74 0Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18.351 9a8.424 8.424 0 0 0-7.391-7.365V0h-2v1.642A8.424 8.424 0 0 0 1.629 9H0v2h1.629a8.424 8.424 0 0 0 7.331 7.358V20h2v-1.635A8.424 8.424 0 0 0 18.351 11H20V9h-1.649ZM8.96 5.12V3.662A6.425 6.425 0 0 0 3.647 9H5.12v2H3.647a6.425 6.425 0 0 0 5.313 5.338V14.88h2v1.467A6.425 6.425 0 0 0 16.333 11H14.88V9h1.453a6.425 6.425 0 0 0-5.373-5.347V5.12h-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgBullseye20Px;
